import React, { useState } from "react";
import { Clapperboard, Play } from "lucide-react";
import { Reveal } from "./Reveal";

// Oficjalny film reklamowy DigiLib.store (30 s)
export function PromoVideo() {
  const [playing, setPlaying] = useState(false);
  return (
    <section id="film" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-16 sm:px-6" data-testid="promo-video-section">
      <Reveal>
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-cyan-400/40 bg-cyan-400/10 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-cyan-300">
            <Clapperboard className="h-3.5 w-3.5" /> Aplikacje Edukacyjne DigiLib
          </span>
          <h2 className="mt-5 font-display text-2xl font-bold tracking-tight sm:text-3xl">
            Edukacja nie powinna być <span className="gradient-text">luksusem</span>
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-slate-400">
            30 sekund o tym, dlaczego wiedza, aplikacje i gry edukacyjne kupujesz u nas raz — na zawsze.
          </p>
        </div>
      </Reveal>
      <Reveal delay={120}>
        <div className="relative mt-10">
          <div className="promo-halo pointer-events-none absolute -inset-6 rounded-[2.5rem] bg-gradient-to-r from-cyan-500 via-fuchsia-500 to-teal-400 opacity-70 blur-3xl" />
          <div
            className="glow-border group relative overflow-hidden rounded-3xl p-[3px]"
            style={{ animationDuration: "2.5s" }}
            data-testid="promo-video-frame"
          >
            <div className="relative overflow-hidden rounded-[calc(1.5rem-3px)]">
              <video
                data-testid="promo-video"
                className="block w-full bg-black transition-all duration-700 group-hover:saturate-125"
                controls
                preload="none"
                playsInline
                poster="/img/promo/poster-reklama.jpg"
                src="/video/digilib-reklama.mp4"
                onPlay={() => setPlaying(true)}
                onPause={() => setPlaying(false)}
                onEnded={() => setPlaying(false)}
              />
              {!playing && <span className="promo-shine" />}
            </div>
          </div>
        </div>
      </Reveal>
      <Reveal delay={200}>
        <p className="mt-6 flex items-center justify-center gap-2 text-center text-xs text-slate-500">
          <Play className="h-3.5 w-3.5 text-cyan-400" /> Włącz dźwięk — film ma lektora i ścieżkę dźwiękową
        </p>
      </Reveal>
    </section>
  );
}
